<div class="login-failed">
  <mat-icon class="material-icons-outlined login-failed__icon">lock</mat-icon>
  <div class="login-failed__header">Login Failed</div>
  <div class="login-failed__info">
    The authentication has failed. <br />Please try again or contact your administrator.
  </div>
  <a mat-flat-button class="login-failed__button" [href]="'overview'">Go Home</a>
</div>
